module.exports = __webpack_public_path__ + "img/dew-point-temp.92ec9ee3.svg";